const status = {
	1: "Active",
	2: "Inactive",
	3: "Pending",
	4: "Schedule",
};

const statusByName = {
	Active: 1,
	Inactive: 2,
	Pending: 3,
	Schedule: 4,
};

module.exports = { status, statusByName };
